import { AutomobileRiskModels } from './automobile-risk.models';
import { CommonRiskModels } from './common-risk.models';
import { CommonModels } from './common.models';
import { DocumentModels } from './document.models';
import { HealthModels } from './health.models';
import { PaymentModels } from './payment.models';
import { PolicyModels } from './policy.models';

export namespace QuotationModels {
  import Resiliation = HealthModels.Resilisation;

  export interface BrokerPricingMetadatas {
    commission: CommonModels.MinMaxMetric;
    management: CommonModels.MinMaxMetric;
    hasFixedBrokerData: boolean;
    formulas: Formula[];
  }

  export interface QuotationPaymentCredentials {
    birthDate: string;
    publicId: string;
  }

  export interface QuotationStatusData {
    status: QuotationStatusEnum;
    assure: CommonRiskModels.AssureInfos;
    clientId?: number;
    policyId?: number;
    ria?: Resiliation;
    suiviUrl?: string;
  }

  export interface QuotationDetails {
    commission: number;
    fees: number;
    formula: FormulaEnum;
    formulaDetails: FormulaDetails;
  }

  export interface FormulaChoice {
    formula: QuotationModels.FormulaEnum;
    optionalWarranties: QuotationModels.WarrantyEnum[];
  }

  export interface BrokerFeesChoice {
    type: CommissionTypeEnum;
    healthRateLinear?: HealthModels.HealthRateLinearEnum;
    healthRateWithholding?: HealthModels.HealthRateWithholdingEnum;
    loading: number;
    management: number;
  }
  export interface Navigator {
    iPAddress: string;
    userAgent: string;
    isDesktop: boolean | null;
    navigator: string;
  }

  export enum CommissionTypeEnum {
    Linear = 1,
    Withholding = 2,
  }

  export interface QuotationSummary {
    status: QuotationStatusEnum;
    lastPaymentStatus: PaymentModels.PaymentTransactionInfos;
    subscriptionInfo: SubscriptionForm;
    risk: AutomobileRiskModels.Form;
    details: QuotationDetails;
    brokerConsultingFileUrl: string;
    cgFileUrl: string;
    ipidFileUrl: string;
    quotationFileUrl: string;
    toPayMonthly: number;
    toPayYearly: number;
    nextToPayMonthly: number;
    monthsForFirstPayment: number;
    nextToPayYearly: number;
    fees: number;
    vehicle?: PolicyModels.VehicleDetails;
    ria?: HealthModels.Resilisation;
  }

  export interface Quotation<TRisk> {
    status: QuotationStatusEnum;
    risk: TRisk;
    files: QuotationFile[];
  }

  export interface QuotationFile {
    url: string;
    type: DocumentModels.DocumentType;
  }

  export interface QuotationTableRow {
    remaininNumber?: number;
    remaining?: string;
    publicId: string;
    lastName: string;
    firstName: string;
    brokerName: string;
    creationDate: Date;
    signatureReadyDate?: Date;
    civility: CommonModels.CivilityEnum;
    insuranceType: CommonModels.InsuranceTypeEnum;
    status: QuotationModels.QuotationStatusEnum;
    id: number;
    isArchiving: boolean;
    isVad?: boolean;
    isRappel?: boolean;
    isCallFromProspect?: boolean;
    package: PolicyModels.PackageEnum;
  }

  export enum QuotationStatusEnum {
    InProgress = 1,
    WaitingPayzen = 2,
    Paid = 3,
    Converted = 4,
    Archived = 5,
    WaitingSignature = 6,
    Signed = 7,
  }
  export interface BrokerPricingData {
    metadatas: BrokerPricingMetadatas;
    currentCommission: number;
    currentManagement: number;
    currentFormula: Formula;
    currentPackageId: number;
    pricing: PricingWithCommissions;
  }

  export interface Formula {
    type: FormulaEnum;
    warranties: FormulaWarranty[];
    optionalWarranties: OptionalFormulaWarranty[];
    pricing: PricingWithCommissions;
  }

  export interface FormulaWarranty {
    warranty: WarrantyEnum;
    isAvailable: boolean;
    franchise?: number;
  }

  export interface FormulaDetails {
    optionnalWarranties: FormulaDetailsWarranty[];
  }

  export interface FormulaDetailsWarranty {
    selected: boolean;
    type: QuotationModels.WarrantyEnum;
  }

  export enum FranchiseEnum {
    BrisDeGlace = 1,
    IncendieVol = 2,
    DommageToutAccident = 3,
  }
  export interface PricingInfosResponse {
    fees: number;
    pricing: Staggered<DetailedPricing>;
    pricingRate: PricingRate;
  }

  export interface PricingRate {
    brokerCommissionRate: number;
    brokerLoadingRate: number;
    wazariCommissionRate: number;
    wazariLoadingRate: number;
    wazariStaggeringRate: number;
    monthsForFirstPayment: number;
  }

  export interface DetailedPricing {
    clientTotalPrice: number;
    firstClientPayment: number;
    productsPricing: any[];
  }

  export interface Staggered<T> {
    yearly: T;
    monthly: T;
  }

  export interface OptionalFormulaWarranty {
    warranty: WarrantyEnum;
    selected: boolean;
    pricing: Pricing;
  }

  export interface PricingWithCommissions {
    client?: Pricing;
    broker?: Pricing;
    fees?: number;
  }

  export interface FullFormulaPricingInformations {
    formula: PricingWithCommissions;
    franchises: { [warrantyEnum: number]: number };
    optionalWarranties: { [warrantyEnum: number]: Pricing };
  }

  export interface Pricing {
    monthly: number;
    yearly: number;
  }

  export interface SubscriptionInfo {
    dateEffet: string;
    quantieme?: number;
  }

  export interface SubscriptionForm {
    quittancement?: QuittancementEnum;
    infos: SubscriptionInfo;
  }

  // Enums
  export enum BoiteDeVitesseEnum {
    Automatique = 1,
    Manuelle = 2,
  }

  export enum QuittancementEnum {
    Mois = 1,
    Annuel = 12,
  }

  export enum AncienneteContratEnum {
    MoinsUnAn = 1,
    PlusUnAn = 2,
  }

  export enum CarrosserieEnum {
    Berline_3_Portes = 1,
    Berline_4_Portes = 2,
    Berline_5_Portes = 3,
    Berline = 4,
    Break_3_Portes = 5,
    Break_4_Portes = 6,
    Break_5_Portes = 7,
    Break = 8,
    Chassis_Double_Cabine = 9,
    Cabriolet = 10,
    Combi = 11,
    Chassis_Cabine = 12,
    Commercial_3_Portes = 13,
    Commercial_5_Portes = 14,
    Commercial_Break = 15,
    Commerciale = 16,
    Chassis_Nu = 17,
    Coupe = 18,
    Camionnette = 19,
    Divers = 20,
    Fourgon = 21,
    Familial = 22,
    Fourgonnette = 23,
    Limousine = 24,
    Ludospace = 25,
    Minibus = 26,
    Monospace = 27,
    Plateau_Double_Cabine = 28,
    Plateau_Cabine = 29,
    Plancher_Cabine = 30,
    Pick_Up = 31,
    Plateau_Ridelles = 32,
    Pick_Up_Double_Cabine = 33,
    Tous_Terrains = 34,
    Vehicule_Tout_Chemin = 35,
  }

  export enum DureeSuspensionEnum {
    None = 0,
    De1A3Mois = 5,
    De4A6Mois = 1,
    De7A12Mois = 2,
    De13A24Mois = 3,
    PlusDe24Mois = 4,
  }

  export enum EnergieEnum {
    Essence = 1,
    Gasoil = 2,
    BioEthanol = 3,
    Electrique = 4,
    GazNaturelDeVille = 5,
    Gpl = 6,
  }

  export enum FinancementEnum {
    Comptant = 1,
    Credit = 2,
    Leasing = 3,
    Donation = 4,
  }

  export enum GarageEnum {
    GarageFerme = 1,
    ParkingCollectifPleinAir = 2,
    VoiePublique = 3,
    JardinClosPrive = 4,
    ParkingFermeCollectif = 5,
    GaragePublicSurveille = 6,
  }

  export enum GrammeMesureAlcoolemieEnum {
    Entre50Et79 = 6,
    Entre80Et100 = 1,
    Entre101Et125 = 2,
    Entre126Et150 = 3,
    Entre151Et175 = 7,
    Entre176Et200 = 4,
    Entre200Et225 = 5,
    Entre226Et250 = 8,
    Entre251Et275 = 9,
    Entre276Et300 = 10,
    PlusDe300 = 11,
  }

  export enum LitresMesureExpireEnum {
    Entre250et399 = 6,
    Entre400et500 = 1,
    Entre501Et620 = 2,
    Entre630Et750 = 3,
    Entre760Et870 = 7,
    Entre880Et1000 = 4,
    Entre1010Et1120 = 5,
    Entre1130Et1250 = 8,
    Entre1260Et1370 = 9,
    Entre1380Et1500 = 10,
    PlusDe1500 = 11,
  }

  export enum NombreKilometresAnnuelEnum {
    De0A4999 = 1,
    De5000A7999 = 2,
    De8000A11999 = 3,
    De12000A15999 = 4,
    De16000A24999 = 5,
    De25000A34999 = 6,
    PlusDe35000 = 7,
  }

  export enum NatureSinistreEnum {
    Materiel = 1,
    Corporel = 2,
  }

  export enum PeriodeAssurance36DerniersMoisEnum {
    PasAssurance = 0,
    De1MoisA7Mois = 1,
    De8Mois11Mois = 5,
    De12MoisA15Mois = 2,
    De16MoisA23Mois = 6,
    De24MoisA35Mois = 3,
    SupérieurOuEgale36Mois = 4,
  }

  export enum PeriodeInterruptionEnum {
    Aucun = 0,
    De1A3Mois = 1,
    De4A6Mois = 2,
    PlusDe6Mois = 3,
  }
  export enum ProfessionEnum {
    SalarieNonCadre = 1,
    SalarieCadre = 2,
    Etudiant = 3,
    Fonctionnaire = 4,
    RechercheEmploi = 5,
    Retraite = 6,
    SansProfession = 7,
    ChefDEntreprise = 8,
    ProfessionLiberale = 9,
    Artisan = 10,
    Enseignant = 11,
    Commercant = 12,
    Agriculteur = 13,
    Societe = 14,
    Autre = 15,
  }

  export enum FormulaEnum {
    Basic = 1,
    Confort = 2,
    AllInclusive = 3,

    Sante1 = 200,
    Sante2 = 201,
    Sante3 = 202,
    Sante4 = 203,
    Sante5 = 204,
    Sante6 = 205,
    Sante7 = 206,

    Rop20 = 301,
    Rop30 = 302,
    Rop40 = 303,
    Rop50 = 304,
    Rop60 = 305,
  }

  export enum RaisonResiliationEnum {
    Non = 1,
    NPPMoins3Mois = 2,
    NPP3A6Mois = 3,
    NPPPlus6Mois = 4,
    Sinistre = 5,
    SinistreNPPMoins3Mois = 6,
    SinistreNPP3A6Mois = 7,
    SinistreNPPPlus6Mois = 8,
    SinistreAlcool = 12,
    SinistreStupefiant = 13,
    FaussesDeclarations = 9,
    NulliteContrat = 10,
    Autres = 11,
    DefautPiece = 14,
    DelitDeFuite = 15,
    Alcoolemie = 16,
    Stupefiant = 17,
    AggravationRisque = 18,
  }

  export enum RaisonSuspensionAnnulationEnum {
    Non = 1,
    Alcoolemie = 2,
    AlcoolemieEtGrandExcesVitesse = 17,
    AlcoolemieEtPetitExcesVitesse = 18,
    AlcoolemieEtSinistre = 19,
    AlcoolemieEtSinistreEtExcesVitesse = 20,
    Autre = 6,
    DefautAssurance = 3,
    DelitFuite = 9,
    Stupefiant = 4,
    StupefiantEtGrandExcesVitesse = 11,
    StupefiantEtPetitExcesVitesse = 12,
    StupefiantEtSinistre = 13,
    StupefiantEtSinistreEtExcesVitesse = 14,
    ResistanceOrdrePublic = 15,
    RefusObtemperer = 16,
    RetraitTotalDesPoints = 5,
    PetitExcesVitesse = 21,
    GrandExcesVitesse = 22,
  }

  export enum RaisonCondamnation {
    Aucun = 1,
    ControleAlcoolemiePositif = 2,
    ControleStupefiantPositif = 3,
    PetitExcesVitesse = 4,
    GrandExcesVitesse = 5,
    DefautAssurance = 6,
    DelitDeFuite = 7,
    RefusObtemperer = 8,
    ResistanceOrdrePublic = 9,
    Autre = 10,
  }

  export enum ResponsabiliteSinistreEnum {
    NonResponsable = 1,
    PartiellementResponsable = 2,
    Responsable = 3,
  }

  export enum SinisterStateEnum {
    Open = 1,
    Closed = 2,
    Void = 3,
  }

  export enum SituationFamilialeEnum {
    Celibataire = 1,
    Marie = 2,
    Concubinage = 3,
    Pacse = 4,
    Separe = 5,
    Divorce = 6,
    Veuf = 7,
  }

  export enum SuspensionAnnulationEpoqueEnum {
    // None = 0,
    MoinsDe5ans = 1,
    PlusDe5ans = 2,
  }

  export enum SuspensionAnnulationPermisEnum {
    None = 0,
    Suspendu = 1,
    Annulé = 2,
  }

  export enum TitulaireCarteGriseEnum {
    ConducteurPrincipal = 1,
    ConjointOuConcubin = 2,
    ConducteurPrincipalEtConjointOuConcubin = 3,
    Parents = 4,
    ParentsDuConjointConcubin = 5,
    Societe = 6,
    SocieteDeLeasing = 7,
    Enfant = 8,
  }

  export enum TypeConducteur2Enum {
    Non = 1,
    ConjointConcubin = 2,
    Enfant = 3,
    PereMere = 4,
    AutreMembreFamille = 5,
    Ami = 6,
  }

  export enum TypeMesureAlcoolemieEnum {
    PriseDeSang = 1,
    Ethylotest = 2,
  }

  export enum TypePermisEnum {
    PermisB = 1,
    PermisBAvecConduite = 2,
    PermisEtrangerUe = 3,
    PermisEtrangerHorsUe = 4,
  }

  export enum TypeSinistreEnum {
    Collision = 1,
    BrisDeGlace = 2,
    Vol = 3,
    Stationnement = 4,
    Incendie = 5,
    Vandalisme = 6,
    EvenementsNaturels = 7,
  }

  export enum UsageEnum {
    PriveEtTravail = 1,
    Prive = 2,
    PriveEtPro = 3,
    Pro = 4,
  }

  export enum VehiculeDejaAssureEnum {
    Oui = 1,
    NonDepuisMoinsDe8Jours = 2,
    NonDepuisPlusDe8Jours = 3,
  }

  export enum WarrantyEnum {
    ResponsabiliteCivile = 1,
    IncendieVol = 2,
    BrisDeGlace = 3,
    DommageTousAccidents = 4,
    ProtectionJuridique = 5,
    GarantieDuConducteur = 6,
    Assistance = 7,
    DefenseRecours = 8,
    Incendie = 9,
    CatastropheNaturelle = 10,
    CatastropheTechnologique = 11,
    EvenementClimatique = 12,
    AmenagementEtAccessoires = 13,
    AssistanceAvecVehiculeDeRemplacement = 14,

    PanneMecanique = 100,

    AgeoSanteWarranty = 200,

    InfinitySanteEco = 201,

    AcheelSanteEco = 400,
    AcheelSanteEcoPlus = 401,

    RopAssistanceProtectionJuridique = 301,
  }

  export enum WarrantyDescriptionEnum {
    InfinitySanteEcoDespLineOne = 1,

    AcheelSanteEcoDespLineOne,
    AcheelSanteEcoDespLineTwo,
    AcheelSanteEcoPlusDespLineOne,
    AcheelSanteEcoPlusDespLineTwo,
  }

  export interface ReponseAfiExport {
    produit?: string;
    isDoublon?: string;
    tarifs?: Tarif[];
    tarifsTout?: Tarif[];
    lead_id?: string;
  }

  export interface Tarif {
    codeFormule?: string;
    iD_Cotation?: string;
    iD_Formule?: string;
    isComplet?: string;
    montant?: string;
    ordre?: string;
    produitTarif?: string;
    urlSouscription?: string;
    isNonResponsable?: boolean;
    isMarqueBlanche?: boolean;
    niv_soinsmedicaux?: string | undefined;
    niv_hospitalisation?: string | undefined;
    niv_optique?: string | undefined;
    niv_auditives?: string | undefined;
    niv_dentaire?: string | undefined;
    niv_orthodontie?: string | undefined;
    niv_osteopathie?: string | undefined;
    niv_chiropractie?: string | undefined;
    niv_phytotherapie?: string | undefined;
    niv_thermalisme?: string | undefined;
    niv_ambulatoire?: string | undefined;
    niv_prevention?: string | undefined;
    niv_prevention_sante?: string | undefined;
    niv_prevention_sante_enfant?: string | undefined;
    niv_prevention_sante_adulte?: string | undefined;
    niv_prevention_sante_senior?: string | undefined;
    niv_prevention_sante_femme?: string | undefined;
    niv_prevention_sante_homme?: string | undefined;
  }

  export interface DocLink {
    CG?: string; //Conditions Génerale,
    FID?: string; //Fiche d'Informations Produits,
    TG?: string; //Tableau de Garantie
    AnnexeVAD?: string; //Annexe sur le droit de rénonciation
    FraisGestion?: string;
  }

  export enum TypePicto {
    Nouveau = 'Nouveau',
    Promo = 'Promo',
    FraisDossierOffert = 'FraisDossierOffert',
  }

  export interface Produit {
    nom_produit?: string;
  }

  export enum DocType {
    CG = 'CG', //Conditions Génerale,
    FID = 'FID', //Fiche d'Informations Produits,
    TG = 'TG', //Tableau de Garantie
    AnnexeVAD = 'AnnexeVAD', //Annexe sur le droit de rénonciation
    FraisGestion = 'FraisGestion',
  }
}

// public class ReponseAfiExport
// {
// 	public bool IsDoublon { get; set; }

// 	public List<Tarif> Tarifs { get; set; }
// }

// public class Tarif
// {

// 	public string CodeFormule { get; set; }

// 	public int ID_Cotation { get; set; }

// 	public int ID_Formule { get; set; }

// 	public bool IsComplet { get; set; }

// 	public decimal Montant { get; set; }

// 	public int Ordre { get; set; }

// }
